import { createI18n } from 'vue-i18n';

function loadLocaleMessages() {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\/([^/]+)\.json$/i);
    if (matched && matched.length > 2) {
      const locale = matched[1];
      const filename = matched[2];
      if (!messages[locale]) {
        messages[locale] = {};
      }
      const fileMessages = locales(key);
      // It's a good practice to namespace the messages by filename
      // to avoid key collisions between files.
      messages[locale][filename] = fileMessages;
    }
  });
  
  // A function to merge all nested message objects into a single object per locale
  const mergeMessages = (localeMessages) => {
    const merged = {};
    for (const key in localeMessages) {
      Object.assign(merged, localeMessages[key]);
    }
    return merged;
  };

  const finalMessages = {};
  for (const locale in messages) {
    finalMessages[locale] = mergeMessages(messages[locale]);
  }
  
  return finalMessages;
}

// Получаем язык из localStorage или определяем по браузеру
const savedLanguage = localStorage.getItem('user-language');
const browserLanguage = navigator.language.split('-')[0];
const defaultLocale = 'ru';

const i18n = createI18n({
  legacy: false,
  locale: savedLanguage || browserLanguage || defaultLocale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ru',
  messages: loadLocaleMessages(),
  // silentTranslationWarn: true,
  // missingWarn: false,
  // fallbackWarn: false,
});

export default i18n; 